export default __webpack_public_path__ + "static/media/wecover2.25c003ac.png";